/* eslint-disable react/jsx-no-target-blank */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'ui/shared/containers';
import { analytics } from 'util/analytics';

require('./CuratedContentDialog.css');
const elev8LogoSrc = require('assets/images/elev8-logo.png');

export type Props = {
    visible: boolean;
    onClose(): void;
};

export const CuratedContentDialog = ({ visible, onClose }: Props) => {
    const { t } = useTranslation();

    const handleClickLearnMore = useCallback(() => {
        analytics.event('Elev8 Curated Content', 'click', 'Learn More popup link');
        onClose();
    }, [ onClose ]);

    const handleClickClose = useCallback(() => {
        analytics.event('Elev8 Curated Content', 'click', 'close popup');
        onClose();
    }, [ onClose ]);

    return (
        <Dialog
            id={ 'curated-content-dialog' }
            visible={ visible }
            titleKey={ '' }
        >
            <div className='dialog-content'>
                <div className="_line1">
                    Did you know you can get curated content on your elevator screens?
                </div>
                <div className="_line2">
                    <span className='_line_text'>Unlock new functionality with </span>
                    <img id="elev8-logo" alt='Elev8' src={ elev8LogoSrc }></img>
                </div>
                <a
                    id="learn-more"
                    className="ui tiny red primary button"
                    href="https://www.verticalcity.com/mad-elev8-information-page"
                    target="_blank"
                    onClick={ handleClickLearnMore }
                >
                    Learn More
                </a>
                <button
                    id="close"
                    className="ui tiny basic white icon button"
                    onClick={ handleClickClose }
                >
                    <i className="ui close icon"/>
                </button>
            </div>

        </Dialog>
    );
};
